import React, { useState, useRef, useCallback, useEffect, ReactNode } from "react";
import ReactDOM from "react-dom";
import { Modal, Button, message, Tooltip, Select, Radio } from "antd";
import Tab from "../../components/Tab";
import { TabKeyType, SelectType, tab, tabAllList } from "../../components/Tab/config";
import {
  ContactShowType,
  SelectGroupType,
  UserSelTab
} from "@jd/focus-desktop-comps/lib/es/UserSelection";
import {
  folderTypeEnum,
  getJoySpaceDelPermission,
  getJoySpaceEditPermission,
  getJoySpaceReadAllPermission,
  getJoySpaceReadOnlyPermission,
  getJoySpaceReadWritePermission,
  joyspacePermissionType
} from "../../config/permissions.config";
import {
  addMembers,
  AddMembersParamesType,
  getShareCount,
  sharesCount
} from "../../api/permissions";
import "./index.less";
import events from "../../context/events";
import { ActionFnEnum, ActionType, FileType, OpenFolderStatus, ShareType } from "../../types";
import { openUserSelectionDefaultModal } from "@/utils/modals";
import config, { ConfigEnum } from "@/config/config";
import { getUserInfoApi } from "../../api/pages";
import PermissionSelect from "../../components/PermissionSelect";
import { ListItemData } from "@jd/focus-desktop-comps/lib/es/ListItem";
import { getSharedRecommendList } from "../../api/page";
import IconFont from "@/components/icon";
import addMembersModal from "../AddMembers/index";
import { PermissionEnum } from "../../const";
import { throttle } from "lodash";
import { getFileInfo } from "../../reloadUtils";
import { analysisLog } from "@/utils/logAnalytics";
import { getLoactionFrom } from "../../contextMenus/utils";
import Icon from "@/components/icon";
const { confirm } = Modal;

const { Option } = Select;
interface IProps {
  id: string;
  activeKey?: TabKeyType;
  isModalVisible: boolean;
  type: FileType;
  title: ReactNode;
  permissionType: joyspacePermissionType;
  modalType?: string;
  folderType?: folderTypeEnum;
  isOpenFolder?: OpenFolderStatus;
  isShowManageBtn?: boolean;
  permissions: PermissionEnum[];
  pageType?: any;
  from?: string;
  onUpdata?: (item: any) => void;
  // selectList?: (SelectType | any)[];
  onOk?: (list: any) => void;
  aiConfigName?: string;
}

const parames: AddMembersParamesType = {
  id: "",
  type: FileType.Page,
  dialogueMessage: ShareType.ShareMessage,
  toGroups: [],
  toOrgs: [],
  toUsers: [],
  toEpssUsers: []
};

async function openAddUserModal(props: IProps) {
  const {
    permissionType,
    type,
    id,
    folderType,
    onOk,
    isShowManageBtn = true,
    permissions,
    pageType,
    from,
    aiConfigName = "AI助手",
    onUpdata
  } = props;

  console.log(props, "isShowManageBtnisShowManageBtnisShowManageBtn");
  const user: any = await getUserInfoApi();
  if (!user) {
    console.error("获取用户信息出错");
    return;
  }
  let ddAppId =
    (window as any)?._BTS_CONFIG?.REACT_APP_DD_APPID || process.env.REACT_APP_DD_APPID || "gwork";
  const userData: any = {
    ddAppId,
    userId: user.user_id,
    team: {
      ddAppId,
      teamId: user.tenant_id
    },
    teamUserInfo: {
      ddAppId,
      teamId: user.tenant_id
    }
  };
  let shareType = ShareType.ShareMessage;
  let setChangeItem: any;
  let setChangeDataAll: any;
  let reomveDataAll: any;
  let permissionAllVal: any;
  const editPermissionAll = (val: any) => {
    // if (val === joyspacePermissionType.ReadDel) {
    //     return;
    // }
    permissionAllVal = val;
    setChangeDataAll?.({ permission: val });
  };
  // 埋点上报
  const handleAnalysisLog = () => {
    // @ts-ignore
    const rType = pageType.toString();
    let rFrom = from;
    if (!rFrom) {
      rFrom = getLoactionFrom();
    }
    analysisLog("xtbg_jzb_joyspace_home_1676548210761", "42", rFrom, id, rType);
  };
  const openAddMembersModal = () => {
    handleAnalysisLog();
    addMembersModal({
      id,
      type,
      folderType,
      permissions,
      permissionType: permissionType,
      title: "管理协作者",
      onOk: async () => {
        const res: any = await getFileInfo(type, id);
        if (res === joyspacePermissionType.ReadNothing) {
          console.error("数据异常");
          return;
        }
        if (res && typeof res === "object") {
          res.isFolder = res.page_type ? FileType.Page : FileType.Folder;
          !("title" in res) && (res.title = res.name);
        }
        // onUpdata?.(res);
      }
    });
  };
  // 获取协同人数量
  let count = 0;
  const getPageCount = async () => {
    count = (await sharesCount(id))?.[0] || 0;
  };
  await getPageCount();
  events.on("joyspace:updata_number", getPageCount);
  const onFinish = async (data: any = [], shareType = ShareType.ShareMessage, close = () => {}) => {
    parames.id = id;
    parames.type = type;
    parames.dialogueMessage = shareType;
    parames.toEpssUsers = [];
    parames.toUsers = [];
    parames.toOrgs = [];
    parames.toGroups = [];
    console.log(parames, "dialogueMessage====>");
    if (shareType === 0) {
      analysisLog("xtbg_joyspace_share", "byAI", type.toString(), id);
    }
    for (let item of data) {
      if (item.isDept) {
        parames.toOrgs.push({
          code: item.id,
          permission_type: item.permission || getJoySpaceReadOnlyPermission()
        });
      } else if (item.isGroup) {
        parames.toGroups.push({
          gid: item.id,
          permission_type: item.permission || getJoySpaceReadOnlyPermission()
        });
      } else {
        parames.toEpssUsers.push({
          // id: item.id,
          permission_type:
            item.permission === undefined ? getJoySpaceReadOnlyPermission() : item.permission,
          userId: item.userId || item.origin.info.userId,
          teamId: item.teamId || item.origin.info.teamId
        });
      }
    }
    // eslint-disable-next-line no-debugger
    // debugger;
    addMembers(parames)
      .then((res: any) => {
        if (!res) {
          return;
        }
        // setLoading(false);
        onOk?.(data);
        if (type === FileType.Folder && folderType === folderTypeEnum.MY) {
          events.emit("list.partial.refresh", {
            changeData: {
              id: id,
              type: ActionFnEnum.REMOVE,
              actionType: ActionType.Folder
            }
          });
          events.emit("deleteFolderById", id);
        } else {
          events.emit("list.partial.refresh", {
            changeData: {
              newItem: {
                isShared: true
              },
              id: id,
              type: ActionFnEnum.UPDATE,
              actionType: type === FileType.Page ? ActionType.Page : ActionType.Folder
            }
          });
        }
        if (type === FileType.Folder) {
          //   events.emit("freshLeftTreeByFolderById", "root");
          //   setTimeout(() => {

          events.emit("freshLeftTreeByFolderById", "teamRoot");
          //   }, 700);
        }
        message.success(
          folderType === folderTypeEnum.MY && type === FileType.Folder
            ? "操作成功，该文件夹将移动到【共享文件】"
            : "操作成功"
        );
        // events.emit('changeCount', getPageCount);
        // getPageCount();
        events.off("joyspace:updata");
        events.emit("joyspace:updata", { pageId: id, type });
        close();
      })
      .catch((err) => {
        message.error("操作失败");
        onOk?.(data);
      });
  };
  let result = await getSharedRecommendList(id, 0, 99);
  if (
    result.toString() === "[object Object]" &&
    (result.code === "10001" || result.code === "10002")
  ) {
    result = [];
  }
  let recentlyContactList: ListItemData[] = result.map((item: any, index: number) => {
    switch (item.type) {
      case "user":
        return {
          id: `${item.user_id}:${ddAppId}:${item.tenantId}`,
          name: item.name,
          desc: `${item.org_name}-${item.position_name ? item.position_name : "暂无填写"}`,
          avatar: item.avatar_url,
          userId: item.user_id,
          teamId: item.tenantId,
          app: ddAppId,
          labelInfoList: item.labelInfoList
        };
      case "org": {
        let ids = item.id.split(":");
        // ids.splice(1, 0, ddAppId);
        let fullPath = item.full_path.split("/");
        let parentId = fullPath[fullPath.length - 2] || "0";
        return {
          id: item.code,
          name: item.name,
          avatar: (
            <div className="focus-user-selection-dept-avatar focus-user-selection-dept-avatar-no-background">
              <IconFont type={item.node_type ? "icontiaoxian31" : "iconbumen"} />
            </div>
          ),
          desc: item.full_name,
          origin: { contactNumber: 0 },
          contactNumber: 0,
          deptId: item.code,
          deptName: item.name,
          fullName: item.full_name,
          fullPath: item.full_path,
          parentId,
          teamId: ids[0],
          permission: 2,
          isCustomDept: true,
          isDept: true
        };
      }
      case "group":
        return {
          id: item.gid,
          gid: item.gid,
          name: item.name,
          desc: `${item.memberCount || 0}人`,
          avatar: item.avatar,
          isGroup: true,
          kind: item.kind,
          subKind: item.subKind
        };
      default:
        return item;
    }
  });
  console.log(111, result, recentlyContactList);
  let isFlag = true;
  const onChangeShare = (e: any) => {
    shareType = e.target.value;
  };
  const userModal = openUserSelectionDefaultModal(
    {
      title: (
        <div>
          分享给
          <Tooltip
            placement="top"
            title={
              <div>
                <h4 style={{ color: "#ffffff", fontWeight: "bold" }}>分享说明</h4>
                如果被分享人的已有权限高于本次分享设置的权限，则该用户的权限不会被改变。如需变更用户的权限，请在“协作者管理”中设置。
              </div>
            }
            className="joyspace-operate-tip"
          >
            <Icon type="iconquanjutishi" className="share-tip" />
          </Tooltip>
        </div>
      ),
      tabs: config[ConfigEnum.EXTERNAL_CONTACTS_ORG]
        ? ["custom", "org", "groupCanBeSel", "externalContacts"]
        : ["custom", "groupCanBeSel", "externalContacts"],
      customTabs: [
        {
          tabName: "最近分享",
          dataList: [...recentlyContactList]
        }
      ],
      tabSort: [
        {
          tab: UserSelTab.custom,
          sort: 1
        }
      ],
      contactShowType: ContactShowType.multiTenement,
      // contactsFilterFlag: ["crossPlatform"],
      selectGroupType: SelectGroupType.innerAndCrossTenement,
      notLoad: true,
      //   contactsFilterFlag: "external",
      currentUser: {
        app:
          user.app ||
          (window as any)?._BTS_CONFIG?.REACT_APP_DD_APPID ||
          process.env.REACT_APP_DD_APPID ||
          "",
        pin: user.user_id,
        teamId: user.tenant_id
      },
      canSelectDept: true,
      rightHeaderExtra: (data: any) => {
        if (permissionType === getJoySpaceReadOnlyPermission()) {
          return null;
        }
        return (
          <PermissionSelect
            onChange={editPermissionAll}
            type={type}
            permissionType={permissionType}
            isCheckAll
            propsValue={permissionAllVal}
            isDisableAll={data.some((item: any) => {
              return item.isGroup || item.isDept || item.isWorkLine;
            })}
          />
        );
      },
      rightExtra: {
        // eslint-disable-next-line max-params
        render: (item: any, onChangeItem: any, onChangeDataAll: any) => {
          setChangeItem = onChangeItem;
          setChangeDataAll = onChangeDataAll;
          // reomveDataAll = removeAll;
          return (
            <PermissionSelect
              key={item.id}
              onChange={(values: any) => {
                setChangeItem?.(item, { permission: values });
              }}
              type={type}
              permissionType={permissionType}
              propsValue={
                item.permission === undefined ? getJoySpaceReadOnlyPermission() : item.permission
              }
              isDisableAll={item.isGroup || item.isDept || item.isWorkLine}
            />
          );
        }
      },
      footerExtra: (
        <div className="joyspace-user-footer-left-modal">
          <span>
            已有
            <span className="joyspace-user-footer-count">{count}</span>
            协作者
          </span>
          {
            isShowManageBtn && (
              <Button
                type="text"
                onClick={openAddMembersModal}
                disabled={!permissions?.includes(PermissionEnum.SHARE_MANAGE)}
              >
                管理协作者
              </Button>
            )
            // <span onClick={openAddMembersModal}>管理协作者</span>
            //
          }
        </div>
      ),
      customAreaExtra: (
        <Radio.Group
          onChange={onChangeShare}
          defaultValue={ShareType.ShareMessage}
          style={{ width: "100%" }}
        >
          <Radio className="share-radio" value={ShareType.ShareAI}>
            通过{aiConfigName}分享
            <Tooltip
              placement="topRight"
              title={
                <div>
                  <div>
                    <h4 style={{ color: "#ffffff", fontWeight: "bold" }}>通过{aiConfigName}分享</h4>
                    将通过{aiConfigName}给选中的「联系人/部门/群组」的所有成员发送提醒。
                  </div>
                  <div>
                    <h4 style={{ color: "#ffffff", fontWeight: "bold" }}>通过会话分享</h4>
                    将通过聊天会话给选中的「联系人/群组」发送文档或文件夹；组织架构里的部门不支持通过会话分享。
                  </div>
                </div>
              }
              className="joyspace-operate-tip"
            >
              <Icon type="iconquanjutishi" className="share-tip" style={{ float: "right" }} />
            </Tooltip>
          </Radio>
          <Radio value={ShareType.ShareMessage}>通过会话分享</Radio>
        </Radio.Group>
      )
    },
    (res, close) => {
      if (!isFlag) {
        return;
      }
      isFlag = false;
      console.log(res, "res");
      const data = (res as any).data.result || [];
      data.forEach((item: any) => {
        if (item.isWorkLine) {
          item.isDept = true;
        }
      });
      if (shareType === ShareType.ShareMessage) {
        const isDept = data.some((item: any) => item.isDept);
        // eslint-disable-next-line no-debugger
        // debugger;
        if (isDept) {
          message.error(`不支持通过会话分享给部门，您可选择通过${aiConfigName}分享给部门`);
          isFlag = true;
          return;
        }
      }
      onFinish((res as any).data.result, shareType, close).finally(() => {
        isFlag = true;
      });
      // close();
      events.off("joyspace:updata_number", getPageCount);
    },
    userData
  );
  return userModal;
}

// function mapStateToProps({ user }: { user: UserState }) {
//     return {
//         userData: user.userData.user,
//     };
// }

// function mapDispatchToProps(dispatch: any) {
//     return {};
// }

export default openAddUserModal;
